import capitalise from './capitalise';
import queryString from 'query-string';
import React from 'react';

export const escapeHtml = (str: string): string => {
  const buf: string[] = [];
  for (let i = str.length - 1; i >= 0; i--) {
    buf.unshift(['&#', str[i].charCodeAt(i), ';'].join(''));
  }
  return buf.join('');
};

/**
 * Converts an html characterSet into its original character.
 *
 * @param {String} str htmlSet entities
 **/
export const unescapeHtml = (str: string): string => {
  if (!str) return '';
  return str.replace(/&#(\d+);/g, function(match, dec) {
    return String.fromCharCode(dec);
  });
};

export const extractTemplateTypeFromOmniUrlArgs = omniUrlArgs => {
  return omniUrlArgs.replace('source=SEO_', '');
};

export const getCarTypeForDisplay = (carType: string | null | undefined) => {
  if (carType !== 'SUV') carType = String(capitalise(carType ? carType : ''));

  return carType.replace(/_/, ' ');
};

export const errorToString = err => {
  return String(err.stack)
    .split('\n', 2)
    .join(' ')
    .replace(/ +/g, ' ')
    .replace(/'+/g, '"');
};

const APP_LISTING_LINK_TEMPLATE = `https://applinks.makemytrip.com/cabListing`;
const MWEB_LISTING_LINK_TEMPLATE = `https://cabs.makemytrip.com/cabsListing`;
export const getAppLinkFromDTLink = (url: string | null) => {
  if (!url) return '';
  if (url.startsWith(MWEB_LISTING_LINK_TEMPLATE)) {
    const urlObject = queryString.parseUrl(url);
    const urlParameterObject = {
      deeplink: true,
      tripType: urlObject.query.tripType,
      pickupTime: urlObject.query.pickupTime,
      startDate: urlObject.query.departDate,
      from: urlObject.query.fromCity,
      to: urlObject.query.toCity,
      source: urlObject.query.source,
      case: urlObject.query.case
    };
    return `${APP_LISTING_LINK_TEMPLATE}?${queryString.stringify(
      urlParameterObject
    )}`;
  }
  return url;
};

export const formatText = ({
  text,
  tooltipIcon,
  highlightedText,
  highlightedColor,
  classNameForNonHighightedText = 'blackText',
  className = '',
  classNameForToolTipIcon = '',
  separtor = '*',
  idx
}) => {
  const components: JSX.Element[] = [];
  // higlighted element will be pushed in the first and colored as done for cabs  DT
  if (highlightedText) {
    components.push(
      <span
        key={`${highlightedText}_${idx}`}
        style={{ color: highlightedColor }}
        className={className}
      >
        {highlightedText.replace(/\*/g, '')}
      </span>
    );
  }
  // highlight only string that are within **, taking mod of 2 as every alternaet string falls within ** when split with '*' as separtor
  text.split(separtor).forEach((subStr, idx) => {
    if (idx % 2 == 0)
      components.push(
        <span
          key={`${subStr}_${idx}`}
          style={{ marginRight: '2px' }}
          className={classNameForNonHighightedText}
        >
          {subStr}
        </span>
      );
    else {
      components.push(
        <span
          key={`${subStr}_${idx}`}
          style={{ marginRight: '2px' }}
          className={className}
        >
          {subStr}
        </span>
      );
    }
  });
  if (tooltipIcon) {
    components.push(
      <span key={`${tooltipIcon}_${idx}`} style={{ marginLeft: '2px' }}>
        <img className={classNameForToolTipIcon} src={tooltipIcon}></img>
      </span>
    );
  }
  return components;
};

export const getColorGradientClassByRating = (rating: number): string => {
  let bgClass = '';
  switch (true) {
    case rating >= 4:
      bgClass = 'ratingGreenGradientBg';
      break;
    case rating >= 2.5 && rating < 4:
      bgClass = 'ratingOrangeGradientBg';
      break;
    case rating < 2.5:
      bgClass = 'ratingRedGradientBg';
  }
  return bgClass;
};

export const escapeRegexCharacters = str => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

/**
 * Formats booking count persuasion text with special styling
 * Text inside * will be bold and bluish
 * Text inside ~ will be bold and black
 * Regular text will be normal black
 *
 * @param {string} text - The text to format (e.g., "*10 people* booked this cab in last ~7 days~")
 * @returns {JSX.Element[]} Array of formatted React elements
 */
export const formatBookingPersuasion = (text: string): JSX.Element[] => {
  return text.split(/(\*[^*]+\*|~[^~]+~)/).map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      // Text inside * should be bold and bluish
      return (
        <span key={index} className="latoBold" style={{ color: '#008cff' }}>
          {part.slice(1, -1)}
        </span>
      );
    } else if (part.startsWith('~') && part.endsWith('~')) {
      // Text inside ~ should be bold and black
      return (
        <span key={index} className="latoBold blackText">
          {part.slice(1, -1)}
        </span>
      );
    }
    // Regular text
    return (
      <span key={index} className="blackText">
        {part}
      </span>
    );
  });
};
